<template>
  <div class="background-holder overflow-hidden">
    <div class="Program-Holder">
      <div class="Program-Items w-screen md:w-auto overflow-hidden">
        <div class="Program-Items SubHolder">
          <div class="Program-Item Program-Item-2">
            <img class="Program-Item-Image" :src="mn" alt="Menu" />
          </div>
          <div class="Program-Item Program-Item-1">
            <img class="Program-Item-Image" :src="pg" alt="Program" />
          </div>

          <div class="Program-Background-Holder Program-Background-3 md:w-1/3 h-[27rem] md:h-auto w-full">
            <img class="Program-Background object-cover object-top " src="./image.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  

<script>
export default {
  data () {
    return {
        pg:"",
        mn:""
    }
  },
    mounted() {
        const lang = localStorage.getItem('language') || 'fr';
        this.$i18n.locale = lang; if (lang === 'en') {
            this.pg = require('./Programme_eng.png');
            this.mn = require('./Menu_eng.png');
        } else {
            this.pg = require('./programme_fr.png');
            this.mn = require('./Menu_fr.jpg');
        }
    }
};
</script>

<style scoped>
@import './program.css';
</style>